import type { ReactElement, ReactNode } from 'react'

export interface VerweisProps {
  href: string
  gehZu: (pfad: string) => void
  children: ReactNode
  className?: string
  /** Der Eintrag, auf dem man gerade steht — trägt `aria-current="page"`, nicht nur eine Farbe. */
  aktuell?: boolean
}

/**
 * Ein echter Anker mit echtem href — kopierbar, mit der mittleren Maustaste in einem neuen Tab zu öffnen,
 * für Screenreader ein Link — der beim einfachen Linksklick innerhalb der Anwendung navigiert statt die Seite
 * neu zu laden. Modifikatortasten bleiben dem Browser überlassen.
 */
export function Verweis({ href, gehZu, children, className, aktuell }: VerweisProps): ReactElement {
  return (
    <a
      href={href}
      className={className}
      aria-current={aktuell === true ? 'page' : undefined}
      onClick={(ereignis) => {
        if (ereignis.metaKey || ereignis.ctrlKey || ereignis.shiftKey || ereignis.altKey || ereignis.button !== 0) {
          return
        }
        ereignis.preventDefault()
        gehZu(href)
      }}
    >
      {children}
    </a>
  )
}
